import { useSyncExternalStore } from "react";
import { getPaywallReason, type PaywallReason, subscribePaywall } from "@/shared/lib/paywall";

/** Reactive view of the open paywall reason (null when closed). */
export function usePaywallReason(): PaywallReason | null {
  return useSyncExternalStore(subscribePaywall, getPaywallReason, getPaywallReason);
}
